import axios from 'axios'
import { directStoreDispatch } from '../index'
import { logout } from './actions/Member.actions'
import { setAlert } from './actions/Alert.actions'

const axiosWrapper = axios.create({
  baseURL: process.env.REACT_APP_API_HOST,
  responseType: 'json'
})

axiosWrapper.defaults.withCredentials = true

// What the backend said went wrong. Rails puts it in `error`; the Node layer
// rewraps its own failures as `message`.
const reasonFrom = (error) =>
    `${error.response?.data?.error ?? error.response?.data?.message ?? ''}`

// Rails answers 401 for two different things, and only one of them is a
// session that has ended: `Insufficient privileges.` means this member may not
// have that particular thing, and signing them out over it would throw them to
// the login screen for a permission problem on one call.
const isPermissionDenied = (error) =>
    reasonFrom(error).toLowerCase().includes('insufficient privileges')

axiosWrapper.interceptors.response.use(undefined, function (error) {
  // A request that never got a reply has no status to act on, and reading one
  // threw a TypeError in here — inside the handler meant to report failures.
  if (!error.response) return Promise.reject(error)

  if (error.response.status === 401) {
    if (!isPermissionDenied(error)) directStoreDispatch(logout())

    // Never a red bar: a 401 is either handled by signing out or is the
    // caller's own business.
    return Promise.reject(error)
  }

  if (error.response.data?.message) {
    directStoreDispatch(setAlert(error.response.data.message))
  } else {
    directStoreDispatch(
        setAlert(`${error.response?.statusText || 'Something went wrong!'}`)
    )
  }

  return Promise.reject(error)
})

export default axiosWrapper
